import { InvokeCallback, Sender } from "xstate";
import { withToken } from "@rentablo/api";
import {
  listAndSearchAllAccounts,
  ListAndSearchAllAccountsTypeEnum,
} from "@rentablo/api/apiv1";
import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";
import { investmentTypeToAccountType } from "../utils/utils";

export const loadDepots =
  (
    context: TransactionWizardContext
  ): InvokeCallback<TransactionWizardEvent, TransactionWizardEvent> =>
  (callback) => {
    if (!context.investmentValues.type)
      throw new Error("No investment type defined");

    const type = investmentTypeToAccountType(context.investmentValues.type);
    load(callback, type);
  };

const load = async (
  callback: Sender<TransactionWizardEvent>,
  type: ListAndSearchAllAccountsTypeEnum
) => {
  try {
    const accountList = await withToken(listAndSearchAllAccounts)({
      type: [type],
    });
    callback({
      type: "DEPOTS_LOADED",
      depots: (accountList.accounts ?? []).map((account) => {
        return {
          id: account.id,
          name: account.name,
          currency: account.currency,
        };
      }),
    });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
